import { RetirementUnit } from './retirement-unit.model';
import { UtilityAccount } from './utility-account.model';

export class CapitalRetirement {
  utilityAccountBeingRemoved: UtilityAccount;
  retirementUnit: RetirementUnit;
  retirementUnitOptions: RetirementUnit[];
  originalInstalledYear: number;
  quantity: number;
  address: string;
}
